import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  text: 'Take the Gap Signal Test to map your current state of "cellular hunger."'
}, {
  num: '2',
  text: 'Follow the 21-day nutritional saturation schedule designed to refill your reserves.'
}, {
  num: '3',
  text: 'Watch your 3:00 PM yawns disappear and your mental clarity return.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-116">
      <div className="text-center mb-16" data-id="element-117">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-118">How It Works</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-119">
        <div className="hidden md:block absolute top-1/2 left-0 w-full h-[1px] bg-forest/20 -translate-y-1/2 z-0" data-id="element-120"></div>

        {steps.map((step, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} className="relative z-10 flex flex-col items-center text-center bg-offwhite p-6" data-id="element-121">
            <div className="w-16 h-16 rounded-full bg-forest text-amber flex items-center justify-center text-2xl font-serif font-bold mb-6 border-4 border-offwhite shadow-sm" data-id="element-122">
              {step.num}
            </div>
            <p className="text-lg text-charcoal/80 font-medium leading-relaxed" data-id="element-123">
              {step.text}
            </p>
          </motion.div>)}
      </div>
    </section>;
}